import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 40,  suffix: "+",   label: "Años de Experiencia" },
  { value: 500, suffix: "+",   label: "Proyectos Completados" },
  { value: 100, suffix: "+",   label: "Clientes Satisfechos" },
  { value: 3,   suffix: "",    label: "Especialidades Certificadas" },
];

function Counter({ to, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1800;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(to * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, to]);

  return (
    <span ref={ref} className="font-playfair text-5xl sm:text-6xl text-brand-gold leading-none">
      {n}
      <span className="text-brand-gold/80">{suffix}</span>
    </span>
  );
}

export default function StatsBar() {
  return (
    <section
      data-testid="stats-bar"
      className="relative bg-brand-navy text-white py-16 lg:py-20 overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 bg-blueprint-dark bg-grid-40 opacity-50" />
      <div aria-hidden className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-brand-navy" />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid grid-cols-2 lg:grid-cols-4 gap-y-12 lg:gap-y-0 lg:divide-x lg:divide-brand-gold/30">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: "easeOut" }}
            className="lg:px-8 text-center lg:text-left"
            data-testid={`stat-${i}`}
          >
            <Counter to={s.value} suffix={s.suffix} />
            <div className="mt-3 font-mont text-[11px] uppercase tracking-[0.22em] text-white/70">
              {s.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
